const formatMessageWithShortName = ({
  message,
  shortName,
  splitCharacters = [" - ", " - "]
}) => {
  let finalMessage = message;

  if (typeof message === "string" && shortName) {
    let parts = [];
    let splitCharacter;

    for (const character of splitCharacters) {
      const newParts = message.split(character);

      if (newParts.length > 1) {
        parts = newParts;
        splitCharacter = character;
        break;
      }
    }

    if (parts.length > 1) {
      const rest = parts.slice(1);
      finalMessage = [shortName, ...rest].join(splitCharacter);
    }
  }

  return finalMessage;
};

export default formatMessageWithShortName;
